import { useCallback, useEffect, useState } from "react";
import { useInvitationService } from "../../hooks/useInvitationService";
import { useStore } from "zustand";
import globalStore from "../../../../state";

export type LegacySeatsData = {
    hasSeparateSeatLimits: boolean;
    rbacInfo: any;
    totalSeatsRemaining: number;
    isLoaded: boolean;
    refresh: () => void;
};

export const useLegacySeatsData = (externalRefreshKey = 0): LegacySeatsData => {
    const invitationService = useInvitationService();
    const { workspace, workspaceId } = useStore(globalStore, (state) => ({
        workspace: state.workspacesById?.[state.currentWorkspaceId || ""],
        workspaceId: state.currentWorkspaceId
    }));
    const [refreshKey, setRefreshKey] = useState(0);
    const [serviceData, setServiceData] = useState<LegacySeatsData>({
        hasSeparateSeatLimits: false,
        rbacInfo: {
            adminInvitesRemaining: 0,
            labelerInvitesRemaining: 0,
            reviewerInvitesRemaining: 0
        },
        totalSeatsRemaining: 0,
        isLoaded: false,
        refresh: () => {}
    });

    const refresh = useCallback(() => setRefreshKey((k) => k + 1), []);

    useEffect(() => {
        if (workspaceId && invitationService && workspace) {
            try {
                const hasSeparateSeatLimits = invitationService.hasSeparateSeatLimits();
                const rbacInfo = invitationService.getRBACSeatsRemaining();
                const totalSeatsRemaining = invitationService.getTotalSeatsRemaining();

                setServiceData({
                    hasSeparateSeatLimits,
                    rbacInfo,
                    totalSeatsRemaining,
                    isLoaded: true,
                    refresh
                });
            } catch (err) {
                setServiceData((prev) => ({ ...prev, isLoaded: true, refresh }));
            }
        }
    }, [workspaceId, invitationService, workspace, refreshKey, externalRefreshKey, refresh]);

    return serviceData;
};
